import InquiryForm from './InquiryForm';

export default InquiryForm;